import React from 'react';
import PropTypes from 'prop-types';
import AbacusContext from './Context';
import {initializeAbacus} from '../../utils/AbacusUtil';
import AbacusExperiments from '../../utils/AbacusExperiments';
import AbacusClientUtils from '@homeaway/abacus-client-utils';
import * as Sentry from '@sentry/browser';
import {isDirectNavMlSourced} from '../../utils/DirectNavUtils';

class AbacusProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
        };
    }
    // TODO: Investigate storing in state instead of class level static.
    // eslint-disable-next-line react/sort-comp
    static errorCount = 0;
    static maxErrCount = 10;

    static getDerivedStateFromProps(nextProps, prevState) {
        let nextState = prevState;
        if (!nextState.abacusPromise) {
            nextState.hasId = nextProps.hasId;
            nextState.havId = nextProps.havId;
            nextState.abov = nextProps.abov;
            nextState.directNavSource = nextProps.directNavSource;
            nextState.abacusPromise = initializeAbacus(
                nextState.havId,
                nextState.hasId,
                nextState.abov
            );
            nextState.loaded = false;
            nextState.experiments = {};
            for (let experimentName in AbacusExperiments) {
                if (AbacusExperiments.hasOwnProperty(experimentName)) {
                    Object.defineProperty(
                        nextState.experiments,
                        AbacusExperiments[experimentName],
                        {
                            get() {
                                let evaluationData = {value: 0};
                                if (
                                    AbacusExperiments[experimentName] !==
                                        'Vrbo_VT_Direct_Nav_Only' ||
                                    !isDirectNavMlSourced(nextState.directNavSource)
                                ) {
                                    evaluationData = AbacusClientUtils.evaluateExperimentAndLog(
                                        AbacusExperiments[experimentName]
                                    );
                                    if (
                                        evaluationData.hasOwnProperty('exception') &&
                                        AbacusProvider.errorCount < AbacusProvider.maxErrCount
                                    ) {
                                        AbacusProvider.errorCount++;
                                        Sentry.withScope((scope) => {
                                            scope.setExtra('hasId', nextProps.hasId);
                                            scope.setExtra('havId', nextProps.havId);
                                            scope.setExtra('experimentName', experimentName);
                                            Sentry.captureException(
                                                new Error(
                                                    `Abacus error with experimentName=${AbacusExperiments[experimentName]}`
                                                )
                                            );
                                            Sentry.flush(1000);
                                        });
                                    }
                                }
                                return evaluationData;
                            },
                        }
                    );
                }
            }
        } else if (
            nextProps.hasId !== prevState.hasId ||
            nextProps.havId !== nextState.havId ||
            nextProps.abov !== nextState.abov
        ) {
            throw new Error('AbacusClientUtils does not support re-initialization');
        }
        return nextState;
    }

    componentDidMount(): void {
        if (this.state.abacusPromise) {
            this.state.abacusPromise.then(() => {
                this.setState({
                    ...this.state,
                    loaded: true,
                });
            });
        }
    }

    render() {
        return (
            <AbacusContext.Provider value={this.state.experiments}>
                {this.state.loaded ? this.props.children : null}
            </AbacusContext.Provider>
        );
    }
}

AbacusProvider.propTypes = {
    hasId: PropTypes.string,
    havId: PropTypes.string,
    abov: PropTypes.string,
    directNavSource: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default AbacusProvider;
